import BaseView from '../core/baseView';

export default BaseView.extend({

    $elements: null,
    switchProperty: null,
    updateProperty: null,

    initialize: function () {

        this.$elements = this.$('>.js-slider--container');
        this.switchProperty = this.$el.data('modelSwitchProperty');
        this.updateProperty = this.$el.data('modelPropertyToUpdate');

        /*
        If model and switch property is set, start listening to model changes
         */
        if (this.model && this.switchProperty) {
            this.listenTo(this.model, 'change:' + this.switchProperty, this.onSwitchPropertyChange);
            this.onSwitchPropertyChange();
        }
    },

    getSwitchValue: function () {
        return this.model.get(this.switchProperty);
    },

    onSwitchPropertyChange: function () {

        var $visibleElement;

        this.$elements.addClass('is-hidden');

        $visibleElement = this.$elements.filter('[data-group-item-id="' + this.getSwitchValue() + '"]').removeClass('is-hidden');

        /*
        If group should update model, do it here
         */
        if (this.updateProperty) {
            this.model.set(this.updateProperty, (Boolean($visibleElement.length)));
        }

        /*
        Also, trigger event on that element so connected slider view can know that it became just visible
         */
        if ($visibleElement.length > 0) {
            $visibleElement.trigger('sliderBecameVisible');
        }
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/sliders/SliderGroup.js
 **/